import React from 'react'
import { Grid, Box, Typography } from '@material-ui/core'
import lodash from 'lodash'

import FactoryCard from './FactoryCard'

export default function FactoryList(props) {
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  const { factories } = props

  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */
  return (
    <Grid container spacing={3}>
      {/* EMPTY STATE */}
      {lodash.isEmpty(factories) && (
        <Grid item xs={12}>
          <Box
            height="200px"
            bgcolor="grey.800"
            justifyContent="center"
            display="flex"
            alignItems="center"
          >
            <Typography variant="subtitle2">This dealer don't have any factory yet.</Typography>
          </Box>
        </Grid>
      )}
      {/* EMPTY STATE */}

      {/* FACTORY CARDS */}
      {lodash.map(factories, (f, key) => (
        <FactoryCard key={key} factory={f} factoryID={key} setIsFetchingFactories={props.setIsFetchingFactories} preparePage={props.preparePage} dealerID={props.dealerID} />
      ))}
      {/* FACTORY CARDS */}
    </Grid>
  )
}
